import { render, staticRenderFns } from "./updateRole.vue?vue&type=template&id=08c1ba04&"
import script from "./updateRole.vue?vue&type=script&lang=js&"
export * from "./updateRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports